export const ACCOUNT_HOLDER_DETAILS_REQUEST = "ACCOUNT_HOLDER_DETAILS_REQUEST";
export const ACCOUNT_HOLDER_DETAILS_SUCCESS = "ACCOUNT_HOLDER_DETAILS_SUCCESS";
export const ACCOUNT_HOLDER_DETAILS_FAILURE = "ACCOUNT_HOLDER_DETAILS_FAILURE";
export const ACCOUNT_HOLDER_UPDATE_SUCCESS = "ACCOUNT_HOLDER_UPDATE_SUCCESS";
export const ACCOUNT_HOLDER_UPDATE_REQUEST = "ACCOUNT_HOLDER_UPDATE_REQUEST";
export const ACCOUNT_HOLDER_UPDATE_FAILURE = "ACCOUNT_HOLDER_UPDATE_FAILURE";

export const ESIGN_HISTORY_REQUEST = "ESIGN_HISTORY_REQUEST";
export const ESIGN_HISTORY_SUCCESS = "ESIGN_HISTORY_SUCCESS";
export const ESIGN_HISTORY_FAILURE = "ESIGN_HISTORY_FAILURE";